import React, { Fragment, useEffect, useRef, useState } from 'react';
import nprogress from "nprogress";
import "nprogress/nprogress.css";

const Index = () => {
  useEffect(() => {
    nprogress.start()

    return () => {
      nprogress.done()
    }
  })

  return ''
}

export default Index